import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const StatusWarningSmall = props => (
  <StyledIcon viewBox='0 0 12 12' a11yTitle='StatusWarningSmall' {...props}>
    <polygon fillRule='evenodd' stroke='#000' strokeLinejoin='round' points='6 1 11 10 1 10' />
  </StyledIcon>
);
